import { computed } from 'vue';
import { useInjectSize } from '../SizeContext';
import { useInjectDisabled } from '../DisabledContext';
/**
 * Read size / disabled from the nearest ConfigProvider.
 * Aligns with React `ConfigProvider.useConfig()` (antd ≥ 5.3.0).
 */
export function useConfig() {
    const size = useInjectSize();
    const disabled = useInjectDisabled();
    return {
        componentSize: computed(() => size.value),
        componentDisabled: computed(() => disabled.value),
    };
}
export default useConfig;
